import { Link } from "react-router-dom";
import * as Icons from "lucide-react";
import { ArrowUpRight, Flame } from "lucide-react";
import { SECTORS } from "@/lib/sectors";
import { SECTOR } from "@/constants/testIds";

export default function SectorGrid() {
    return (
        <section className="section-pad bg-slate-50 relative overflow-hidden">
            <div className="absolute inset-0 grid-bg-faint opacity-60 pointer-events-none" />
            <div className="container-x relative">
                <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-12">
                    <div className="max-w-2xl">
                        <span className="text-eyebrow">10 claim types · UK-wide</span>
                        <h2 className="mt-3 text-3xl sm:text-4xl lg:text-5xl font-display font-bold tracking-tight text-navy-900">
                            Which type of claim can we help you with?
                        </h2>
                        <p className="mt-5 text-base text-slate-600 leading-relaxed">
                            We specialise in the UK&apos;s hottest claim sectors — covering finance, housing, injury and consumer rights. One free check tells you if you qualify.
                        </p>
                    </div>
                </div>

                <div data-testid={SECTOR.grid} className="grid sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 lg:gap-5">
                    {SECTORS.map((s) => {
                        const Icon = Icons[s.icon] || Icons.Scale;
                        return (
                            <Link
                                key={s.slug}
                                to={`/sectors/${s.slug}`}
                                data-testid={SECTOR.card(s.slug)}
                                className="group relative card-soft card-soft-hover p-6 flex flex-col"
                            >
                                {s.hot && (
                                    <span className="absolute top-4 right-4 inline-flex items-center gap-1 rounded-full bg-amber-50 border border-amber-200 text-amber-700 text-[10px] font-bold uppercase tracking-wider px-2 py-1">
                                        <Flame className="w-3 h-3" /> Hot
                                    </span>
                                )}
                                <div className="w-12 h-12 rounded-xl bg-emerald-50 border border-emerald-100 flex items-center justify-center group-hover:bg-emerald-600 group-hover:border-emerald-600 transition-colors">
                                    <Icon className="w-6 h-6 text-emerald-600 group-hover:text-white transition-colors" />
                                </div>
                                <h3 className="mt-5 text-lg font-display font-semibold text-navy-900 leading-tight">{s.name}</h3>
                                <p className="mt-2 text-sm text-slate-500 leading-relaxed flex-1">{s.short}</p>
                                <div className="mt-5 pt-4 border-t border-slate-100 flex items-center justify-between text-sm">
                                    <div>
                                        <div className="text-[11px] uppercase tracking-wider text-slate-400 font-semibold">Avg. payout</div>
                                        <div className="text-navy-900 font-bold text-sm">{s.averagePayout}</div>
                                    </div>
                                    <div className="w-9 h-9 rounded-full bg-slate-100 group-hover:bg-emerald-600 flex items-center justify-center transition-colors">
                                        <ArrowUpRight className="w-4 h-4 text-slate-500 group-hover:text-white transition-colors" />
                                    </div>
                                </div>
                            </Link>
                        );
                    })}
                </div>
            </div>
        </section>
    );
}
